import { HttpClient } from '@angular/common/http';
import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-svg-icon',
    templateUrl: './svg-icon.component.html',
    standalone: false
})
export class svgIconComponent {
  @Input()
  public name?: string;

  public svgIcon: any;

  constructor(
    private httpClient: HttpClient,
    private sanitizer: DomSanitizer,
    ) {
  }

  public ngOnChanges(): void {
    if (!this.name) {
      this.svgIcon = '';
      return;
    }
    if (this.name.startsWith('data:image/svg+xml;base64,')) {
      // Decode the base64 part
      const base64Data = this.name.split(',')[1];
      const decodedSvg = atob(base64Data);
      this.svgIcon = this.sanitizer.bypassSecurityTrustHtml(decodedSvg);
    } else {
      // Handle case when it's a normal SVG URL (optional)
      fetch(this.name)
        .then(res => res.text())
        .then(svg => {
          this.svgIcon = this.sanitizer.bypassSecurityTrustHtml(svg);
        });
    }
    // this.httpClient
    //   .get(`${this.name}`, { responseType: 'text' })
    //   .subscribe(value => {
    //     this.svgIcon = this.sanitizer.bypassSecurityTrustHtml(value);
    //   });
  }
}